//Intra City Types
export const SET_INTRACITY_PICKUP_DROP_LOCATION = "SET_INTRACITY_PICKUP_DROP_LOCATION";
export const SET_INTRACITY_PACKAGES = "SET_INTRACITY_PACKAGES";
export const ADD_INTRACITY_PICKUP_DROP_LOCATION = "ADD_INTRACITY_PICKUP_DROP_LOCATION";
export const ADD_INTRACITY_PACKAGES = "ADD_INTRACITY_PACKAGES";
export const SET_INTRACITY = "SET_INTRACITY"
export const RESET_INTERCITY = "RESET_INTERCITY"
export const CONFIRMED_BOOKING = "CONFIRMED_BOOKING"

//Part Load Types
export const SET_PARTLOAD_PICKUP_DROP_LOCATION = "SET_PARTLOAD_PICKUP_DROP_LOCATION";
export const SET_PARTLOAD_PACKAGES = "SET_PARTLOAD_PACKAGES";
export const ADD_PARTLOAD_PICKUP_DROP_LOCATION = "ADD_PARTLOAD_PICKUP_DROP_LOCATION";
export const ADD_PARTLOAD_PACKAGES = "ADD_PARTLOAD_PACKAGES";
export const SET_PARTLOAD = "SET_PARTLOAD";
export const SET_QUICK_ORDER = "SET_QUICK_ORDER";
export const SET_BOOKING_TRACKING = "SET_BOOKING_TRACKING";
export const SET_BOOKING_RESET_TRACKING = "SET_BOOKING_RESET_TRACKING";

export interface setIntraCityPickupDropLocations {
    type: typeof SET_INTRACITY_PICKUP_DROP_LOCATION;
    payload: {
        what: any,
        val: any,
        index: number
    };
}

export interface setIntraCityPackages {
    type: typeof SET_INTRACITY_PACKAGES;
    payload: {
        what: any,
        val: any,
        index: number
    };
}